module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inReach":"{bleAsset} within reach","outOfReach":"{bleAsset} no longer within reach"},"de":{"inReach":"{bleAsset} in Reichweite","outOfReach":"{bleAsset} nicht mehr in Reichweite"},"fr":{"inReach":"{bleAsset} à portée","outOfReach":"{bleAsset} plus à portée"},"it":{"inReach":"{bleAsset} a portata di mano","outOfReach":"{bleAsset} non più a portata di mano"}}')
  delete Component.options._Ctor
}
